import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useReveal } from "@/hooks/useReveal";
import Hero from "./components/Hero";
import FeaturedCharacters from "./components/FeaturedCharacters";
import CharacterCategories from "./components/CharacterCategories";
import FeaturedWorks from "./components/FeaturedWorks";
import WhyUs from "./components/WhyUs";
import Testimonials from "./components/Testimonials";
import FaqPreview from "./components/FaqPreview";
import ContactCta from "./components/ContactCta";
import { faqs } from "@/mocks/faqs";

const jsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "萌妖图鉴",
    url: "https://mangami2.github.io/",
    description: "韩国妖精漫画角色图鉴站，整理女主颜值与人设、萌娘属性、CP组合与人物关系。",
  },
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "萌妖图鉴",
    description: "韩国妖精漫画角色资料整理与爱好者交流平台",
    email: "contact@yaojing-tujian.example.com",
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  },
];

export default function Home() {
  usePageMeta(
    "韩国妖精漫画角色图鉴｜女主萌娘人设·CP组合·妖精漫画一站查",
    "韩国妖精漫画角色图鉴站，专注整理妖精漫画女主颜值与人设、萌娘属性、CP组合与人物关系。想看某部韩国妖精漫画的角色介绍，从这里直接点进对应作品页即可。",
    jsonLd
  );
  useReveal();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <FeaturedCharacters />
        <CharacterCategories />
        <FeaturedWorks />
        <WhyUs />
        <Testimonials />
        <FaqPreview />
        <ContactCta />
      </main>
      <Footer />
    </div>
  );
}